import { render, staticRenderFns } from "./index.vue?vue&type=template&id=717bd66c"
import script from "./userDetailsData.js?vue&type=script&lang=js&external"
export * from "./userDetailsData.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports